<script lang="ts" setup>
// #左圖右文
import { type Text } from '@/utils/types/TextEditor'
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const textData = ref()
const imgData = ref()

if (props.data) {
  const text: Ref<Text> = ref(props.data.text)
  const img: Ref<Image> = ref(props.data.image)
  textData.value = text.value
  imgData.value = img.value
}
</script>

<template>
  <div class="area">
    <div class="area__title">{{ textData }}</div>
    <figure class="area__pic">
      <Nimg :src="imgData?.link" :title="imgData?.title" :alt="imgData?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  &__title {
    font-size: toRem(28);
    font-weight: 500;
    text-align: center;
    padding-bottom: toRem(20);

    @include max-media(580) {
      font-size: toRem(22);
      padding-bottom: toRem(15);
    }
  }

  &__pic {
    img {
      display: block;
      width: 100%;
    }
  }
}
</style>